import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import login from '@/components/login/login'
import keywordList from '@/components/CreateCategory/keywordList'
import keyword from '@/components/CreateCategory/keyword'
import smsList from '@/components/sms/smslist'
import sms from '@/components/sms/sms'
import feelist from '@/components/fee/feelist'
import feedetail from '@/components/fee/feedetail'
import received from '@/components/fee/received'
import uncollected from '@/components/fee/uncollected'
import pos from '@/components/pos/index'
import doshi from '@/components/doshi/index'
import venueInfoDoshi from '@/components/doshi/venueInfo'
import connetVenue from '@/components/doshi/connetVenue'
import createVenue from '@/components/doshi/createVenue'
// venue account
import account from '@/components/account/index'
import master from '@/components/account/master'
import alter from '@/components/account/edit'
import create from '@/components/account/create'
import createMaster from '@/components/account/createMaster'
import editMaster from '@/components/account/editMaster'
import detail from '@/components/account/detail'
import venueInfo from '@/components/account/venueInfo/index'
import proLoss from '@/components/account/proLoss/index'
import week from '@/components/account/DeRoster/week'
import deputy from '@/components/account/DeRoster/index'
import inner from '@/components/account/DeRoster/detail'
import labour from '@/components/account/labour/index'
import profit from '@/components/account/profit/index'
import cost from '@/components/account/cost/index'
import expense from '@/components/account/expense/index'
import shiftConfiguration from '@/components/account/shiftConfiguration/index'
// import employee from '@/components/account/employee/index'

// 2021/01/30
import poslist from '@/components/pos/index'
import posadd from '@/components/pos/add'
import posedit from '@/components/pos/edit'
import doshii from '@/components/doshii/index'
import createvenue from '@/components/doshii/create'
import doshiilink from '@/components/doshii/link'
import doshiidetail from '@/components/doshii/detail'
import connect from '@/components/doshii/connect'

import delivery from '@/components/doshii/delivery'

// setting
import Setting from '@/components/setting/index'
import Version from '@/components/setting/version'

import discount from '@/components/discount/index'
import Eos from '@/components/eos/index'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta:{
        requireAuth: true
      },
      children:[
        {
          path: '/setting',
          name: 'setting',
          component: Setting,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },
        {
          path: '/end-of-shift',
          name: 'eos',
          component: Eos,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },
        {
          path: '/version',
          name: 'version',
          component: Version,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },
        {
          path: '/poslist',
          name: 'poslist',
          component: poslist,
          meta:{
            requireAuth: true,
            keepAlive: true,
            isUseCache: false // 默认缓存
          }
        },
        {
          path: '/posadd',
          name: 'posadd',
          component: posadd,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },
        {
          path: '/posedit/:id',
          name: 'posedit',
          component: posedit,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },
        {
          path: '/doshii',
          name: 'doshii',
          component: doshii,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },
        {
          path: '/doshiilink',
          name: 'doshiilink',
          component: doshiilink,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },
        {
          path: '/delivery',
          name: 'delivery',
          component: delivery,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },
        {
          path: '/doshiidetail/:id',
          name: 'doshiidetail',
          component: doshiidetail,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },
        {
          path: '/connect/:id',
          name: 'connect',
          component: connect,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },
        {
          path: '/createvenue/:id',
          name: 'createvenue',
          component: createvenue,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },

        { // key list
          path:'/keywordList',
          name:'keywordList',
          component:keywordList,
          meta: {
            keepAlive: false
          }
        },
        { // add or edit keyword
          path:'/keyword',
          name:'keyword',
          component:keyword,
          meta: {
            keepAlive: false
          }
        },
        { // smsList
          path:'/smsList',
          name:'smsList',
          component:smsList,
          meta: {
            keepAlive: false
          }
        },
        { // add or edit sms
          path:'/sms',
          name:'sms',
          component:sms,
          meta: {
            keepAlive: false
          }
        },
        { // fee list
          path:'/feelist',
          name:'feelist',
          component:feelist,
          meta: {
            keepAlive: false
          }
        },
        { // fee detail
          path:'/feedetail',
          name:'feedetail',
          redirect: "/feeDetail/received",
          component:feedetail,
          children:[
            {
              path:'/feeDetail/received',
              name:'received',
              component:received
            },
            {
              path:'/feeDetail/uncollected',
              name:'uncollected',
              component:uncollected
            },
          ],
          meta: {
            keepAlive: false
          }
        },
        { // pos
          path:'/pos',
          name:'pos',
          component:pos
        },
        { // doshi
          path:'/doshi',
          name:'doshi',
          component:doshi
        },
        {
          path:'/venueInfo-doshi',
          name:'venueInfoDoshi',
          component:venueInfoDoshi
        },
        {
          path:'/connet-venue',
          name:'connetVenue',
          component:connetVenue
        },
        {
          path:'/create-venue',
          name:'createVenue',
          component:createVenue
        },
        {
          path: '/account',
          name: 'account',
          component: account,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },
        {
          path: '/master',
          name: 'master',
          component: master,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },

        {
          path: '/alter/:id',
          name: 'alter',
          component: alter,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },
        {
          path: '/create',
          name: 'create',
          component: create,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },
        {
          path: '/createmaster',
          name: 'createmaster',
          component: createMaster,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },
        {
          path: '/editmaster/:id',
          name: 'editmaster',
          component: editMaster,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },

        {
          path: '/detail',
          name: 'detail',
          component: detail,
          meta:{
            requireAuth: true,
            keepAlive: false
          },
          children: [
            {
              path: 'info/:id',
              name: 'venueInfo',
              component: venueInfo,
              meta:{
                requireAuth: true,
                keepAlive: false
              }
            },
            {
              path: 'proloss/:id',
              name: 'proLoss',
              component: proLoss,
              meta:{
                requireAuth: true,
                keepAlive: false
              }
            },
            {
              path: 'week/:id',
              name: 'week',
              component: week,
              meta:{
                requireAuth: true,
                keepAlive: false
              }
            },
            {
              path: 'deputy/:id/:time',
              name: 'deputy',
              component: deputy,
              meta:{
                requireAuth: true,
                keepAlive: false
              }
            },
            {
              path: 'inner/:id/:time',
              name: 'inner',
              component: inner,
              meta:{
                requireAuth: true,
                keepAlive: false
              }
            },
            {
              path: 'labour/:id',
              name: 'labour',
              component: labour,
              meta:{
                requireAuth: true,
                keepAlive: false
              }
            },
            {
              path: 'profit/:id',
              name: 'profit',
              component: profit,
              meta:{
                requireAuth: true,
                keepAlive: false
              }
            },
            {
              path: 'cost/:id',
              name: 'cost',
              component: cost,
              meta:{
                requireAuth: true,
                keepAlive: false
              }
            },
            {
              path: 'expense/:id',
              name: 'expense',
              component: expense,
              meta:{
                requireAuth: true,
                keepAlive: false
              }
            },
            {
              path: 'shift-configuration/:id',
              name: 'shift-configuration',
              component: shiftConfiguration,
              meta:{
                requireAuth: true,
                keepAlive: false
              }
            }
            /*{
              path: 'employee/:id',
              name: 'employee',
              component: employee,
              meta:{
                requireAuth: true,
                keepAlive: false
              }
            }*/
          ]
        },
        {
          path: '/discount',
          name: 'discount',
          component: discount,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: login
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

const originalPush = Router.prototype.push
  Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js